const emailRegex = new RegExp(/^(?=.{1,256}$)[^\s@]+@[^\s@]+\.[^\s@]+$/);

export const isValidEmail = (email: string): boolean => emailRegex.test(email);

export const isValidPhoneNumber = (number: string): boolean =>
  !/\D/.test(number);
